import * as React from "react";
const SvgReload20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M4 10a6 6 0 0 0 11.572 2.231l1.856.744A8.002 8.002 0 0 1 2 10a8 8 0 0 1 8-8c2.866 0 4.777 1.424 6 3.084V2h2v7h-7V7h3.866C13.934 5.374 12.428 4 10 4a6 6 0 0 0-6 6Z",
      clipRule: "evenodd"
    })
  );
export default SvgReload20Px;
